import React, { useEffect, useState } from "react";
import ClientInsurence from "./ClientInsurence";
import ClientPrivatePay from "./ClientPrivatePay";
import ClientSubscriptionPlan from "./ClientSubscriptionPlan";

const PatientPayment = ({ info, getprofile }) => {
  const [Insurance, setInsurance] = useState(true);
  const [PrivatePay, setPrivatePay] = useState(false);
  const [SubscriptionPlan, setSubscriptionPlan] = useState(false);

  const handlePaymentMethod = (method) => {
    setInsurance(method === "insurance");
    setPrivatePay(method === "privatePay");
    setSubscriptionPlan(method === "SubscriptionPlan");
  };

  return (
    <div style={{ padding: 20 }}>
      <h2 className="notifications__title">Select Payment Method</h2>
      <p className="payment-description">
        Choose a method for payment. You can bill your insurance, pay privately,
        or subscribe to a plan for additional benefits.
      </p>
   
      <div className="payment-section">
        <div
          className={`payment-method ${Insurance ? "active" : ""}`}
          onClick={() => handlePaymentMethod("insurance")}
        >
          <input
            type="radio"
            id="insurance"
            name="payment_type"
            value="insurance"
            checked={Insurance} 
            readOnly
          />
          <label htmlFor="insurance">🏥 Bill the Client's Insurance</label>
        </div>

        <div
          className={`payment-method ${PrivatePay ? "active" : ""}`}
          onClick={() => handlePaymentMethod("privatePay")}
          title="💳 Patient pays out-of-pocket for this service."
        >
          <input
            type="radio"
            id="private_pay"
            name="payment_type"
            value="private_pay"
            checked={PrivatePay}
            readOnly
          />
          <label htmlFor="private_pay">💳 Private Pay (Out-of-Pocket)</label>
        </div>

        {/* <div
          className={`payment-method ${SubscriptionPlan ? "active" : ""}`}
          onClick={() => handlePaymentMethod("subscriptionPlan")}
        >
          <input
            type="radio"
            id="subscription"
            name="payment_type"
            value="subscription"
            checked={SubscriptionPlan}
            readOnly
          />
          <label htmlFor="subscription">Subscription Plan</label>
        </div> */}
        <div
          className={`payment-method ${SubscriptionPlan ? "active" : ""}`}
          onClick={() => handlePaymentMethod("SubscriptionPlan")}
        >
          <input
            type="radio"
            id="subscription"
            name="payment_type"
            value="subscription"
            checked={SubscriptionPlan}
            readOnly
          />
          <label htmlFor="subscription">📦 Subscription Plan </label>
        </div>
      </div>
      {Insurance && <ClientInsurence />}
      {PrivatePay && <ClientPrivatePay getprofile={getprofile} info={info} />}
      {SubscriptionPlan && <ClientSubscriptionPlan info={info} getprofile={getprofile}/>}
    </div>
  );
};

export default PatientPayment;
